import { render } from "./NotApplicableRadio.vue?vue&type=template&id=4f15c30c&scoped=true&ts=true"
import script from "./NotApplicableRadio.vue?vue&type=script&lang=ts"
export * from "./NotApplicableRadio.vue?vue&type=script&lang=ts"

import "./NotApplicableRadio.vue?vue&type=style&index=0&id=4f15c30c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f15c30c"]])

export default __exports__